// HS code suggestions are AI output, not customs rulings (owner, 2026-10-12).
// Shown under every list of suggestions in the supplier product form.
//
// The server sends the same sentence with each reply
// (supabase/functions/maabar-ai/hsCode.ts → HS_DISCLAIMER). This copy is what
// the UI shows when the reply carries none, so the notice never depends on the
// network. hsCodeDisclaimer.test.js fails if the two copies drift apart.
export const HS_SUGGESTION_DISCLAIMER = {
  ar: 'اقتراح آلي من الذكاء الاصطناعي وليس تصنيفًا جمركيًا رسميًا. تحقّق من الرمز مع هيئة الزكاة والضريبة والجمارك أو مخلّصك الجمركي قبل الاعتماد عليه.',
  en: 'AI-generated suggestion, not an official tariff classification. Confirm the code with Saudi customs (ZATCA) or your customs broker before relying on it.',
  zh: '此为 AI 生成的建议，并非官方海关归类。使用前请向沙特海关（ZATCA）或您的报关行确认编码。',
};

export function hsSuggestionDisclaimer(lang, serverText) {
  const fromServer = typeof serverText === 'string' ? serverText.trim() : '';
  if (fromServer) return fromServer;
  return HS_SUGGESTION_DISCLAIMER[lang] || HS_SUGGESTION_DISCLAIMER.ar;
}
